//const lclArray = ['LCL', 'CHR', 'CHFL', 'CH', 'CHRT', 'CHF1', 'CHF2', 'CH1P', 'CH2P', 'CHAR-E-F', 'CHAR-E-F2P-X', 'CHAR-I-F', 'CHAR-I-F1P-X', 'CHAR-E-FR', 'CHFR'];

const lclArray = [
    'LCL', 'CHR', 'CHFL', 'CH', 'CHRT', 'CHF1', 'CHF2', 'CH1P', 'CH2P',
    'CHAR-E-F', 'CHAR-E-F2P-X', 'CHAR-I-F', 'CHAR-I-F1P-X', 'CHAR-E-FR', 'CHFR',
    'CHAR-I-F1P-X', 'CHAR-E-F1P-X', 'CHAR-I-F', 'BATT-CHAR-000', 'CHAR-E-FR',
    'CHAR-I-F2P-X', 'CHAR-E-1P-X', 'CHAR-E-F', 'CHAR-E-F2P-X', 'CHAR-I-1P-X',
    'ZL-2F', 'ZL-2F-1P20', 'ZL-2F-2P20', 'ZL-1P20', 'ZL-2P20', "ZONE-E-F1P-X",
    "ZONE-E-F1P-X-NB", "ZONE-E-F", "ZONE-E-F-NB", "ZONE-E-F2P-X", "ZONE-E-F2P-X-NB",
    "ZONE-E-1P-X", "ZONE-I-1P-X", "ZONE-E-2P-X", "ZONE-I-2P-X", "Awaiting Config"
];


const isLCLLogger = (model: string | undefined): boolean => {

    if (model?.startsWith("CHAR-") || model?.startsWith("ZL-") || model?.startsWith("ZONE-") || model?.startsWith("Awaiting"))
        return true
    else
        return model != null ? lclArray.includes(model) : false;
}


export { isLCLLogger }